/**
 * Naming convention:
 * - load
 * - store
 * - list
 * - show
 * - update
 * - delete
 * Example:
 * LOAD_POSTS_REQUEST: 'LOAD_POSTS_REQUEST',
 * LOAD_POSTS_FAILURE: 'LOAD_POSTS_FAILURE',
 * LOAD_POSTS_SUCCESS: 'LOAD_POSTS_SUCCESS',
 */

// auth.js
export const AUTH_STATUS_LOADING = 'AUTH_STATUS_LOADING';
export const AUTH_STATUS_SUCCESS = 'AUTH_STATUS_SUCCESS';
export const AUTH_STATUS_ERROR = 'AUTH_STATUS_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const SHOW_ME_SUCCESS = 'SHOW_ME_SUCCESS';
export const SHOW_ME_ERROR = 'SHOW_ME_ERROR';

// members.js
export const LOAD_MEMBERS_LOADING = 'LOAD_MEMBERS_LOADING';
export const LOAD_MEMBERS_SUCCESS = 'LOAD_MEMBERS_SUCCESS';
export const LOAD_MEMBERS_ERROR = 'LOAD_MEMBERS_ERROR';
export const LIST_MEMBERS_LOADING = 'LIST_MEMBERS_LOADING';
export const LIST_MEMBERS_SUCCESS = 'LIST_MEMBERS_SUCCESS';
export const LIST_MEMBERS_ERROR = 'LIST_MEMBERS_ERROR';
export const STORE_MEMBER_ERROR = 'STORE_MEMBER_ERROR';
export const STORE_MEMBER_SUCCESS = 'STORE_MEMBER_SUCCESS';
export const STORE_MEMBER_LOADING = 'STORE_MEMBER_LOADING';
export const UPDATE_MEMBER_ERROR = 'UPDATE_MEMBER_ERROR';
export const UPDATE_MEMBER_SUCCESS = 'UPDATE_MEMBER_SUCCESS';
export const UPDATE_MEMBER_LOADING = 'UPDATE_MEMBER_LOADING';
export const DELETE_MEMBER_LOADING = 'DELETE_MEMBER_LOADING';
export const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS';
export const DELETE_MEMBER_ERROR = 'DELETE_MEMBER_ERROR';

// departments.js
export const LOAD_DEPARTMENTS_LOADING = 'LOAD_DEPARTMENTS_LOADING';
export const LOAD_DEPARTMENTS_SUCCESS = 'LOAD_DEPARTMENTS_SUCCESS';
export const LOAD_DEPARTMENTS_ERROR = 'LOAD_DEPARTMENTS_ERROR';
export const LIST_DEPARTMENTS_LOADING = 'LIST_DEPARTMENTS_LOADING';
export const LIST_DEPARTMENTS_SUCCESS = 'LIST_DEPARTMENTS_SUCCESS';
export const LIST_DEPARTMENTS_ERROR = 'LIST_DEPARTMENTS_ERROR';
export const LIST_ROLES_LOADING = 'LIST_ROLES_LOADING';
export const LIST_ROLES_SUCCESS = 'LIST_ROLES_SUCCESS';
export const LIST_ROLES_ERROR = 'LIST_ROLES_ERROR';

// upload.js
export const UPLOAD_IMAGE_ERROR = 'UPLOAD_IMAGE_ERROR';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_LOADING = 'UPLOAD_IMAGE_LOADING';